import epsClient from 'enrollment-platform/api/eps.client'
import { GetContributionsResponse } from 'enrollment-platform/pages/CustomerManagement/pages/ViewCustomer/tabs/Contribution/types/get-contribution-response.dto'

export async function getContributions(
  clientPublicKey?: string | null,
  year?: number
): Promise<GetContributionsResponse> {
  const { data } = await epsClient.get<GetContributionsResponse>(
    `/customers/${clientPublicKey}/contributions/${year}`
  )
  return data
}
